export default function DOM_Nodes() {
  return (
    <div>
      <h1>DOM_Nodes</h1>
      <p>This is the DOM_Nodes component.</p>
    </div>
  );
}